<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						戰隊競賽
					</li>
				</ol>
			</nav>
			<div class="item-box mb-3">
				<h3 class="item-title">臺版獎勵說明</h3>
				<h4 class="item-sub-title">戰隊競賽</h4>
				<p>
					第一階段 : 1~3 <br>
					第二階段 : 4~9 <br>
					第三階段 : 10~25 <br>
					第四階段 : 26~ <br>
				</p>
				<p>
					<img src="/uploads/%E5%85%AC%E5%91%8A%E7%94%A8%E5%9C%96/20230926.png" alt="" width="100%"><br>
					2023/09/26
					05:00起，將舉辦「9月戰隊競賽」！<br>
					<br>
					■戰隊競賽舉辦期間<br>
					2023/09/26 05:00 ～ 2023/09/30
					23:59<br>
					<br>
					■任務<br>
					隨著戰隊競賽的開幕，將追加期間限定的任務。<br>
					・於9月戰隊競賽（戰隊模式）中到達第2階段<br>
					・於9月戰隊競賽（戰隊模式）中到達第3階段<br>
					・於9月戰隊競賽（戰隊模式）中到達第4階段<br>
					上述任務為2023/09/26
					05:00 ～ 2023/11/26 04:59期間限定任務。<br>
					※任務的達成狀況，將會於移動至戰隊競賽主頁面時更新。<br>
					<br>
					■訓練模式解放期間<br>
					2023/09/23 12:00 ～
					2023/09/30
					23:59<br>
					<br>
					■挑戰方法<br>
					想挑戰怪物的話，必須要累積CP(戰隊點數)。<br>
					CP可於通關主線冒險、活動冒險或調查冒險後獲得，並依消耗體力量的不同，CP的獲得量也將有所變化。<br>
					獲得的CP將於每日「05:00」時進行重置。<br>
					<br>
					■挑戰次數<br>
					戰隊成員每人每天最多可向怪物發起3次挑戰。<br>
					此外，每消耗一次挑戰次數僅可進行一次使用遺留時間的戰鬥。<br>
					每天的挑戰次數將於「05:00」時進行重置。<br>
					<br>
					■關於挑戰獎勵<br>
					每次消耗挑戰次數進行完本戰後，皆可獲得「挑戰獎勵」。<br>
					詳細的挑戰獎勵如下所述。<br>
					・戰隊幣×30<br>
					・瑪那×50000<br>
					・女神的秘石×5<br>
					・隨機裝備道具×4<br>
					・隨機裝備道具×3<br>
					※獲得的「挑戰獎勵」將不會發送至禮物盒內，而是直接加進持有數中。<br>
					※只有在消耗挑戰次數的戰鬥後能夠獲得「挑戰獎勵」。<br>
					※在使用遺留時間以及無效的戰鬥中，皆無法獲得「挑戰獎勵」。<br>
					※出現的裝備道具種類以及出現率，將因主角等級的不同而有所差異。<br>
					<br>
					■各模式可獲得的獎勵<br>
					在戰隊模式中，獎勵的種類及數量並無任何變更。<br>
					排名獎勵中僅有記憶碎片與前次有所不同。<br>
					本次可獲得的記憶碎片為「鈴莓的記憶碎片」。<br>
					<br>
					■本次《9月戰隊競賽》<br>
					戰隊競賽獎勵將參照以下:<br>
					第1名：寶石20000、戰隊幣5000、鈴莓的記憶碎片30。<br>
					第2名：寶石15000、戰隊幣5000、鈴莓的記憶碎片30。<br>
					第3名：寶石12000、戰隊幣5000、鈴莓的記憶碎片30。<br>
					第4~20名：寶石10000、戰隊幣5000、鈴莓的記憶碎片30。<br>
					第21~50名：寶石8000、戰隊幣5000、鈴莓的記憶碎片30。<br>
					第51~150名：寶石6000、戰隊幣4500、鈴莓的記憶碎片25。<br>
					第151~300名：寶石4000、戰隊幣4000、鈴莓的記憶碎片20。<br>
					第301~700名：寶石3500、戰隊幣3500、鈴莓的記憶碎片18。<br>
					第701~1500名：寶石3000、戰隊幣3000、鈴莓的記憶碎片16。<br>
					第1501~3000名：寶石2500、戰隊幣2500、鈴莓的記憶碎片14。<br>
					第3001~5000名：寶石2000、戰隊幣2000、鈴莓的記憶碎片12。<br>
					第5001~7000名：寶石1500、戰隊幣1500、鈴莓的記憶碎片10。<br>
					第7001~10000名：寶石1000、戰隊幣1000、鈴莓的記憶碎片8。<br>
					第10001名~15000名：寶石750、戰隊幣750、鈴莓的記憶碎片7。<br>
					第15001名~：寶石500、戰隊幣500、鈴莓的記憶碎片5。<br>
					<br>
					於戰隊競賽期間，營運團隊將每日查證使用外掛、以不當方式進行戰隊競賽取得積分的玩家並予以封鎖，並扣除該玩家的分數後重新計算戰隊的排名。<br>
					<br>
					■注意事項<br>
					1.
					想參加戰隊競賽，必須先有所屬戰隊。<br>
					戰隊將於通關主線冒險 3-1(NORMAL)後開放。<br>
					2. 戰隊競賽的活動期間內，無法進行戰隊的退出、驅逐與解散。<br>
					3.
					戰隊競賽的活動期間結束時，將先對使用外掛的玩家進行調查與處理後，才會發送獎勵或是發表「戰隊模式」的排行。<br>
					將使用外掛的玩家所給予的傷害自總傷害中減去後，排名有可能會發生變動。<br>
					4.
					戰隊競賽的詳細介紹，請點擊遊戲內的底部選單的［選單］，於［幫助］裡的「戰隊競賽」中進行確認。<br>
					5. 戰隊競賽的舉辦期間及其相關內容，有可能不經預告逕行調整。<br>
					<br>
					※So-net
					營運團隊保有活動最終修改與詮釋之權利，實際內容請以遊戲內資訊為準。活動舉辦日期與內容，均有可能未先告知而逕行調整，確切詳情以實際開放時所述為主。
				</p>
				<a href="http://www.princessconnect.so-net.tw/news/newsDetail/2473">官網消息</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Megami',
	data() {
		return {
			upStar: 4,
			nowHave: 0,
			spend: 1,
			maxMemo: 120,
			total: 0,
			noShow: false
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '戰隊競賽',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的戰隊競賽" }
		]
	},
	created: function () { },
	methods: {
		change: function () {


		},
	},
	computed: {
		qq: function () {

		}
	},
	mounted: function () {

	}
}
</script>
<style scoped>
.v-table th {
	background-color: #efefef;
	color: #3e464f;
	text-align: center;
	vertical-align: middle;
}
</style>